import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./refresh.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./refresh.component.scss?ngResource";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { CreateApplicationRoutingConstants } from "../../create-application-routing.constants";
import { AppControllerService } from "../../../app-controller.service";
let RefreshComponent = class RefreshComponent {
    router;
    appControllerService;
    constructor(router, appControllerService) {
        this.router = router;
        this.appControllerService = appControllerService;
    }
    ngOnInit() {
        this.router.navigate([
            AppRoutingConstants.createRouteToView(this.appControllerService.selectedModuleID, CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE)
        ]);
    }
    static ctorParameters = () => [
        { type: Router },
        { type: AppControllerService }
    ];
};
RefreshComponent = __decorate([
    Component({
        selector: "app-refresh",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], RefreshComponent);
export { RefreshComponent };
